import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { hydrate } from 'core/actions/product/state';
import { homeRequest } from 'core/services/product';

export interface IQueueItem {
  courseNodeId: number;
  courseProgressId: number;
  moduleId?: number;
  sessionAttemptId?: number;
}

export interface IQueue {
  progressItems: Record<number, IQueueItem[]>;
}

export const queueSlice = createSlice({
  name: 'queue',
  initialState: { progressItems: {} } as IQueue,
  reducers: {
    queueItem: (state, action: PayloadAction<IQueueItem>) => {
      if (!state.progressItems[action.payload.courseProgressId])
        state.progressItems[action.payload.courseProgressId] = [];

      state.progressItems[action.payload.courseProgressId].push(action.payload);
    },
    clearQueue: state => {
      state.progressItems = {};
    },
  },
  extraReducers: builder => {
    builder.addCase(hydrate, (state, action) => {
      if (action.payload.queue) state = action.payload.queue;
    });
    builder.addCase(homeRequest.pending, (state, action) => {
      state.progressItems[action.meta.arg.courseProgressId] = [];
    });
  },
});

export const { queueItem } = queueSlice.actions;

export default queueSlice.reducer;
